import { useTranslation } from 'react-i18next';
import Spinner from '../layout/Spinner';

const UnderMaintenance = () => {
    const { t } = useTranslation();

    return (
        <>
            <h1 className="title is-2">{t("MAINTENANCE_HEAD")}</h1>
            <Spinner />
            <p dangerouslySetInnerHTML={{ __html: t("MAINTENANCE_TXT") }}></p>
        </>
    )
}

export default UnderMaintenance;